import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { productConfiguratorApi } from '../utils/callApis';
import rootReducer from '../reducers';
import shopifyReducer from '../reducers/shopify_api/ShopifyCIEMSlice';
import imageUploadReducer from '../reducers/image_builder/ImageUploadSlice';
import storeStateReducer from '../reducers/store_state/StoreStateSlice';

function wrapper(initState = {}) {
    const store = configureStore({
        preloadedState: initState.rootReducer ? initState : { rootReducer: initState },
        reducer: {
            [productConfiguratorApi.reducerPath]: productConfiguratorApi.reducer,
            shopifyReducer,
            imageUploadReducer,
            storeStateReducer,
            rootReducer
        },
        devTools: {
            trace: true,
            traceLimit: 25
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(productConfiguratorApi.middleware)
    });
    setupListeners(store.dispatch);
    return store;
}

export default wrapper;
